import { openModal } from './open-modal';
import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common/dist/src/constants/modal-types';
import { getCategories } from '../selectors/categories-selectors';
import { getSiteInfo } from '../selectors/site-info-selectors';
import { getWriters } from '../selectors/writers-selectors';

export const openPostSettings = ({ activeTab, initialValues, postValues, focusOnCloseId, isPublished, canPublish }) => (
  dispatch,
  getState,
) =>
  dispatch(
    openModal(
      {
        type: MODAL_TYPE_POST_SETTINGS,
        props: {
          activeTab,
          canPublish,
          categories: getCategories(getState()),
          initialValues,
          isPublished,
          postValues,
          siteInfo: getSiteInfo(getState()),
          writers: getWriters(getState()),
        },
      },
      focusOnCloseId,
    ),
  );
